export default __webpack_public_path__ + "static/media/GrifitoL-Bold.e983cb21.woff";